import { Flex } from '@cad-arc';

export function FrPage(props: { children: React.ReactNode }) {
    return (
        <Flex flexDirection="column" width="100%" height="100vh" style={{ marginLeft: 0, overflow: 'auto' }}>
            {props.children}
        </Flex>
    );
}
